var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasEntitlementType(_vm.app) && _vm.app.access.display_type === 'html')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.app.access.state)}}):_c('p',{attrs:{"title":_vm.parseEntitlementString(_vm.app.access.state)}},[_vm._v(_vm._s(_vm._f("truncate")(_vm.parseEntitlementString(_vm.app.access.state),_vm.truncate))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }